/**
 * Created by osirvent on 20/01/2016.
 */
angular
    .module('annexaApp')
    .service('AlertsService',['$q', '$http', 'api', '$rootScope', function($q, $http, api, $rootScope) {
        return {
            getAlertsBySignInUser: function (searchType, modificat, page, alertType) {
                var deferrend = $q.defer();
                if($rootScope.LoggedUser) {
                    if (searchType == true) {
                        var url = api.getAlertsByFilter + "?userid=" + $rootScope.LoggedUser.id + "&modificat=" + modificat;
                        if (modificat == 3) {
                        	if (alertType != '')
                        		url = api.getAlertsByFilterPaginated + "?userid=" + $rootScope.LoggedUser.id + "&modificat=" + modificat + "&alertType=" + alertType + "&page=" + page + "&size=10";
                        	else 
                        		url = api.getAlertsByFilterPaginated + "?userid=" + $rootScope.LoggedUser.id + "&modificat=" + modificat + "&page=" + page + "&size=10";
                        } else if (alertType != '') {
                        	url += "&alertType=" + alertType;
                        }
                        $http.get(url)
                            .success(function (data, status) {
                                deferrend.resolve(data);
                            })
                            .error(function (msg, code) {
                                deferrend.reject(msg);
                            });
                    } else {
                        var url = api.getAlertsByFilter + "?userid=" + $rootScope.LoggedUser.id + "&viewed=" + false + "&modificat=" + modificat;
                        if (modificat == 3) {
                        	if (alertType != '')
                                url = api.getAlertsByFilterPaginated + "?userid=" + $rootScope.LoggedUser.id + "&viewed=" + false + "&modificat=" + modificat + "&alertType=" + alertType + "&page=" + page + "&size=10";
                        	else 
                                url = api.getAlertsByFilterPaginated + "?userid=" + $rootScope.LoggedUser.id + "&viewed=" + false + "&modificat=" + modificat + "&page=" + page + "&size=10";
                        } else if (alertType != '') {
                        	url += "&alertType=" + alertType;
                        }
                        $http.get(url)
                            .success(function (data, status) {
                                deferrend.resolve(data);
                            })
                            .error(function (msg, code) {
                                deferrend.reject(msg);
                            });

                    }
                }else{
                    deferrend.reject("No hi ha usuari");
                }
                return deferrend.promise;
            },
            updateAlertsBySignInUser: function (userId) {
                var deferrend = $q.defer();
                $http({
                    method: 'POST',
                    url: api.updateReadAlerts,
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        userId: userId
                    }
                }).success(function (data, status) {
                    deferrend.resolve(data);
                }).error(function (msg, code) {
                   deferrend.reject(msg);
                });
                return deferrend.promise;
            },
            updateAlertViewed: function (id, viewed) {
                var deferrend = $q.defer();
                $http({
                    method: 'POST',
                    url: './api/alerts/updateAlertViewed',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                    	id: id, 
                    	viewed: viewed
                    }
                }).success(function (data, status) {
                    deferrend.resolve(data);
                }).error(function (msg, code) {
                   deferrend.reject(msg);
                });
                return deferrend.promise;
            },
            updateAllAlertViewed: function (userId, viewed) {
                var deferrend = $q.defer();
                $http({
                    method: 'POST',
                    url: './api/alerts/updateAllAlertViewed',
                    headers: {'Content-Type': 'application/json'},
                    params: {
                    	userId: userId, 
                    	viewed: viewed
                    }
                }).success(function (data, status) {
                    deferrend.resolve(data);
                }).error(function (msg, code) {
                   deferrend.reject(msg);
                });
                return deferrend.promise;
            }
        }
    }]);